import useResendStudy, { ResendStudyOptions } from 'components/Flux/Personalized/MyStudies/ActionsCell/useResendStudy';
import { StudyActionTarget } from 'components/Flux/shared/useStudyActions';
import { useResendUploadStudyMutation } from 'services/api/studies';

// Flux Upload: o mesmo diálogo e feedback do Personalizado, com a mutation que invalida 'Study'
export default function useResendUploadStudy(
  study: StudyActionTarget,
  options: ResendStudyOptions,
) {
  return useResendStudy(study, { ...options, useResendMutation: useResendUploadStudyMutation });
}
